/**
 * metric-notices.ts — Registro centralizado de avisos de metricas descontinuadas
 * ou atualizadas por suas fontes de origem.
 *
 * Uso:
 *   import { metricNotices } from '../lib/metric-notices';
 *   const notice = metricNotices['instagram.video_reach'];
 *   // { kind: 'discontinued', titleKey: 'metricNotices.instagramVideoReachTitle', bodyKey: ... }
 *
 * Para adicionar um novo aviso, inclua uma entrada neste mapa. O componente
 * MetricNotice lê daqui e busca os textos via i18n, garantindo consistência.
 *
 * F3 — 2026-06-09
 */

export type MetricNoticeKind = 'discontinued' | 'updated';

export interface MetricNoticeEntry {
  readonly kind: MetricNoticeKind;
  readonly titleKey: string;
  readonly bodyKey: string;
}

/**
 * Mapa de id de metrica -> definicao do aviso.
 *
 * Ids seguem o padrao `<fonte>.<metrica>` para evitar colisao.
 * Os valores de titleKey e bodyKey devem corresponder a entradas em i18n.ts.
 */
export const metricNotices: Readonly<Record<string, MetricNoticeEntry>> = {
  'instagram.video_reach': {
    kind: 'discontinued',
    titleKey: 'metricNotices.instagramVideoReachTitle',
    bodyKey: 'metricNotices.instagramVideoReachBody',
  },
};
